import {
  createPagingStages,
  createFilteringStage,
  createSortStage,
  CustomPipelineFactory,
  createCountPipeline,
  getAggregationResult,
  getAggregationCount,
} from '@/providers/dataProvider';

export const journalEntriesCustomFetcher: CustomPipelineFactory =
  async ({ filter: filterValues, sort, page, perPage, signal }) => {
    const { deletedAt = 'hidden', ...filter } = filterValues;

    const deletedAtMatch = (() => {
      if (deletedAt === 'hidden') {
        return { deletedAt: null };
      }

      if (deletedAt === 'only') {
        return { deletedAt: { $ne: null } };
      }

      return {};
    })();

    const combinedFilter = {
      ...filter,
      ...deletedAtMatch,
    };

    const match = createFilteringStage(combinedFilter);

    const sortStage = createSortStage(sort);

    const pagingPipeline = createPagingStages(page, perPage);

    const resultsPipeline = [match, sortStage, ...pagingPipeline];

    const countPipeline = createCountPipeline([match]);

    const [results, total] = await Promise.all([
      getAggregationResult(
        'vw_admin_journalEntries',
        resultsPipeline,
        signal,
      ),
      getAggregationCount('vw_admin_journalEntries', countPipeline, signal),
    ]);

    return { results, total };
  };
